<template>
  <div id="app" class="page">
    <div class="pg-inner">
      <app-header v-on:toggleMenu="menuOpen=!menuOpen" :class="{admin: isAdminPart}">
        <ul v-if="!isAdminPart">
          <li v-for="(menuItem, mi) in menuItems" class="menu-item" :class="{active: isActive(menuItem), 'mob-only': menuItem.loggedIn}">
            <a :href="resolvedLink(menuItem.link)" v-on:click.prevent="clickItem(menuItem)">
              {{ menuItem.title }}
            </a>
            <ul v-if="menuItem.sub && menuItem.sub.length">
              <li v-for="(menuItem2, m2i) in menuItem.sub">
                <a :href="resolvedLink(menuItem2.link)" v-on:click.prevent="clickItem(menuItem2)" :class="{active: menuItem2.active}">
                  {{ menuItem2.title }}
                </a>
                <ul v-if="menuItem2.sub && menuItem2.sub.length">
                  <li v-for="(menuItem3, m3i) in menuItem2.sub">
                    <a :href="resolvedLink(menuItem3.link)" v-on:click.prevent="clickItem(menuItem3)" :class="{active: menuItem3.active}">
                      {{ menuItem3.title }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>

        <ul v-if="isAdminPart">
          <li :class="{active: $route.name=='admin.videos'}">
            <router-link :to="{name: 'admin.videos'}">Videos</router-link>
          </li>
          <li :class="{active: $route.name=='admin.users'}">
            <router-link :to="{name: 'admin.users'}">Users</router-link>
          </li>
          <li :class="{active: $route.name=='admin.groups'}">
            <router-link :to="{name: 'admin.groups'}">Pkgs</router-link>
          </li>
          <li :class="{active: $route.name=='admin.types'}">
            <router-link :to="{name: 'admin.types'}">Types</router-link>
          </li>
          <li :class="{active: ['admin.specialities', 'admin.aparatus', 'admin.parts', 'admin.props', 'admin.levels'].indexOf($route.name)!=-1}">
            <router-link :to="{name: 'admin.specialities'}">Tags</router-link>
            <ul>
              <li :class="{active: $route.name=='admin.specialities'}">
                <router-link :to="{name: 'admin.specialities'}">Specialities</router-link>
              </li>
              <li :class="{active: $route.name=='admin.aparatus'}">
                <router-link :to="{name: 'admin.aparatus'}">Aparatus</router-link>
              </li>
              <li :class="{active: $route.name=='admin.parts'}">
                <router-link :to="{name: 'admin.parts'}">Parts</router-link>
              </li>
              <li :class="{active: $route.name=='admin.props'}">
                <router-link :to="{name: 'admin.props'}">Props</router-link>
              </li>
              <li :class="{active: $route.name=='admin.levels'}">
                <router-link :to="{name: 'admin.levels'}">Levels</router-link>
              </li>
            </ul>
          </li>
          <li :class="{active: $route.name=='admin.stats'}">
            <router-link :to="{name: 'admin.stats'}">Stats</router-link>
          </li>
          <li :class="{active: $route.name=='admin.tests'}">
            <router-link :to="{name: 'admin.tests'}">Tests</router-link>
          </li>
        </ul>
      </app-header>
      <transition name="tr-section" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
      <notifications />
      <tc-view v-if="tcVisible" />
      <app-footer :menuOpen.sync="menuOpen" />
    </div>
  </div>
</template>
<script>
import mainNav from './mainNav';
export default {
  mixins: [mainNav],
  computed: {
  },
  watch: {
  },
  data: ()=>({
    loggedIn: null,
    selectedPackage: null,
    selectedVideo: null,
    tcVisible: false,
    menuOpen: false,
  }),
  computed: {
    isAdminPart() {
      return this.$route.name.startsWith('admin') ||
             this.$route.name=='content.postedit';
    },
  },
  methods: {
    checkLogin() {
      this.loggedIn=window.appData.currentUser;
    },
    forceUpdateAll(el) {
      el=el || this;
      el.$forceUpdate();
      for(var child of el.$children)
        this.forceUpdateAll(child);
    },
    clickItem(item) {
      if (typeof(item.link)=="string")
        window.open(item.link, "_self");
      if (item.action) {
        this.$emit('action', {name: item.action, args: item.args});
      } else if (item.link) {
        if (typeof(item.link)=="string" && item.link.indexOf("http")==0)
          window.open(item.link, "_self");
        else {
          this.$router.push(item.link);
          this.$emit("update:menuOpen", false);
        }
      }
    },
    resolvedLink(link) {
      if (typeof(link)=="string")
        return link;
      return this.$router.resolve(link).href;
    },
  },
  created() {
    window.appRoot=this;
    this.checkLogin();
  },
}
</script>
